import { FC, useEffect, useState } from 'react'
import { useIsMdScreen, useIsSmScreen, useIsXsScreen } from '../../../../hooks'
import { Box, CircularProgress } from '../../../UI'
import { LoaderProps } from '../types'
import useStyles from './styles'

const PrivateLoader: FC<LoaderProps> = ({ children, loading = true, sx }) => {
  const classes = useStyles()

  const [smScreen] = useIsSmScreen()
  const [xsScreen] = useIsXsScreen()
  const [mdScreen] = useIsMdScreen()
  const smallScreen = xsScreen || smScreen || mdScreen
  const [dots, setDots] = useState(0)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        setDots((dots + 1) % 4)
      }, 500)
      return () => { clearInterval(timer) }
    }
  }, [dots])

  if (children && !loading) {
    return <> {children} </>
  }

  return (
    <Box className={classes.root} sx={[...(Array.isArray(sx) ? sx : [sx]),]}>
      <Box className={classes.center}>
        <CircularProgress color='primary' size={smallScreen ? 56 : 65} thickness={4} />
      </Box>
    </Box>
  )
}

export default PrivateLoader
